import axios from "axios";
import { AxiosError } from "axios";
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
import { Action } from "api/action_types/quote";
import { Action as AuthAction } from "api/action_types/authentication";
import { ActionType } from "api/action_types/quote";
import { ActionType as AuthActionType } from "api/action_types/authentication"; 
import { Slab } from "api/types/quote";
import { url_prefix } from "settings";
import { slab_url } from "../endpoint";

export const deleteSlab = (slab: Slab, id?: number) => {
    return async(dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
        const { user } = getState().authentication;

        dispatch({
            type: ActionType.QUOTE_UPDATING
        });

        dispatch({
            type: ActionType.DELETE_LOCAL_SLAB,
            payload: slab
        });

        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${user.token}`
            }
        }

        const url = `${url_prefix}${slab_url}/${id ? id : 0}/?uuid=${slab.uuid}&`;

        try
        {
            await axios.delete(url, config);

            dispatch({
                type: ActionType.QUOTE_ACTION_SUCCESS
            });
        }
        catch(err)
        {
            if(err instanceof AxiosError){
                dispatch({
                    type: ActionType.QUOTE_ERROR,
                    payload: err.message
                });
                if(err && err.response && err.response.status === 401){
                    dispatch({
                        type: AuthActionType.AUTH_FAILED
                    });
                } 
            }
        }
    }
}


